import { useState } from "react";

interface ShareButtonsProps {
  title: string;
}

export default function ShareButtons({ title }: ShareButtonsProps) {
  const [toast, setToast] = useState("");

  const currentUrl = typeof window !== "undefined" ? window.location.href : "";

  const showToast = (message: string) => {
    setToast(message);
    window.setTimeout(() => setToast(""), 2000);
  };

  const openWindow = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer,width=680,height=560");
  };

  const handleWeibo = () => {
    openWindow(
      `https://service.weibo.com/share/share.php?url=${encodeURIComponent(
        currentUrl,
      )}&title=${encodeURIComponent(title)}`,
    );
  };

  const handleQQ = () => {
    openWindow(
      `https://connect.qq.com/widget/shareqq/index.html?url=${encodeURIComponent(
        currentUrl,
      )}&title=${encodeURIComponent(title)}`,
    );
  };

  const handleWechat = () => {
    showToast("请点击「复制链接」，粘贴到微信中分享");
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(currentUrl);
      showToast("链接已复制");
    } catch {
      showToast("复制失败，请手动复制地址栏链接");
    }
  };

  const buttonClass =
    "flex items-center gap-1.5 rounded-md border border-background-200 bg-background-50 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer md:text-sm";

  return (
    <div className="relative flex flex-wrap items-center gap-2">
      <span className="text-xs text-foreground-500 md:text-sm">分享到：</span>
      <button type="button" className={buttonClass} onClick={handleWeibo}>
        <i className="ri-weibo-fill text-accent-500" aria-hidden="true"></i>
        微博
      </button>
      <button type="button" className={buttonClass} onClick={handleWechat}>
        <i className="ri-wechat-fill text-secondary-600" aria-hidden="true"></i>
        微信
      </button>
      <button type="button" className={buttonClass} onClick={handleQQ}>
        <i className="ri-qq-fill text-primary-500" aria-hidden="true"></i>
        QQ
      </button>
      <button type="button" className={buttonClass} onClick={handleCopy}>
        <i className="ri-link" aria-hidden="true"></i>
        复制链接
      </button>

      {toast && (
        <div className="absolute -top-10 left-0 z-10 rounded-md bg-foreground-900 px-3 py-1.5 text-xs text-background-50">
          {toast}
        </div>
      )}
    </div>
  );
}